import { ApolloLink } from '@apollo/client'

/**
 * @private only to be used in apolloClient.ts
 */
export const timeStartLink = new ApolloLink((operation, forward) => {
  operation.setContext({ startRequest: new Date() })

  return forward(operation)
})
